"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var Icon_1 = tslib_1.__importDefault(require("../Icon"));

var fillIconNames = {
  empty: 'ic_rating_star_12x12_not_filled_gray_200',
  full: 'ic_rating_star_12x12_filled_blue_400',
  half: 'ic_rating_star_12x12_half_filled_blue_400'
};

function Star(_ref) {
  var filled = _ref.filled;
  return jsx_runtime_1.jsx(Icon_1.default, {
    className: "mrt-star",
    name: fillIconNames[filled]
  }, void 0);
}

exports.default = Star;